import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import PageWrapper from "../../components/common/layout/PageWrapper";
import { baseEndpointPaths, getApplicationById } from "../../../services/serviceCalls";
import LibservAdditionalDocView from "../../components/services/additionalDoc/LibservAdditionalDocView";

const LibservAdditionalDocViewPage = ({ titleCode }) => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  return (
    <PageWrapper title={t(`${titleCode}.view`)}>
      <LibservAdditionalDocView serviceFn={getApplicationById(baseEndpointPaths.libservAdditionalDoc, id)} />
    </PageWrapper>
  );
};
export default LibservAdditionalDocViewPage;
